import { action, observable } from 'mobx';

import { MessageType } from '~constants/Constants';

export interface IMessage {
    message?: string;
    transKey?: string;
    msgType?: MessageType;
}

export enum MessageGroup {
    IN_STORE_SIGN_IN_TO_CONTINUE = 'in_store_sign_in_to_continue',
    SIGN_IN_SOCIAL_CONNECTION = 'sign_in_social_connection',
    SIGN_IN = 'sign_in',
    SIGN_UP = 'sign_up',
    ONLINE_SIGN_UP = 'online_sign_up',
    GUEST_CHECKOUT = 'guest_checkout',
    EMAIL = 'email',
    PASSWORD = 'password'
}

export class MessageRepository {
    @observable
    public messages: Map<string, IMessage[]> = new Map();

    @action
    public setMessages = (messageGroup: MessageGroup, messages: IMessage[]) => {
        this.messages.set(messageGroup, messages);
    };

    @action
    public clearMessagesByGroup = (messageGroup: MessageGroup) => {
        this.messages.delete(messageGroup);
    };

    @action
    public clearAllMessages = () => {
        this.messages.clear();
    };
}
